/**
 * Normalizes getUser name fields (snake/camel/Cognito). Ignores profile.name/display_name.
 * @param {Object|null|undefined} profile
 * @returns {{ first: string, last: string, full: string }}
 */
export function getUserProfileNameParts(profile) {
  if (!profile || typeof profile !== "object") return { first: "", last: "", full: "" };
  const first = String(profile.first_name ?? profile.firstname ?? profile.firstName ?? profile.given_name ?? "").trim();
  const last = String(profile.last_name ?? profile.lastname ?? profile.lastName ?? profile.family_name ?? "").trim();
  return { first, last, full: `${first} ${last}`.trim() };
}
